import { render, staticRenderFns } from "./NewDialog.vue?vue&type=template&id=992c36ca&scoped=true"
import script from "./NewDialog.vue?vue&type=script&lang=js"
export * from "./NewDialog.vue?vue&type=script&lang=js"
import style0 from "./NewDialog.vue?vue&type=style&index=0&id=992c36ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "992c36ca",
  null
  
)

export default component.exports